module.exports = __webpack_public_path__ + "img/sixpackcarrier65.15ba8cb5.jpg";